(function () {
  'use strict';

  function initHero(scope) {
    const hero = scope.querySelector ? scope.querySelector('[data-hero]') : null;
    if (!hero || hero.dataset.weiyuReady === 'true') return;

    const section = hero.closest('.shopify-section') || document;
    const dataNode = section.querySelector('[data-hero-slides]') || document.querySelector('[data-hero-slides]');
    const heroImage = hero.querySelector('[data-hero-image]');
    const kicker = hero.querySelector('[data-hero-kicker]');
    const script = hero.querySelector('[data-hero-script]');
    const title = hero.querySelector('[data-hero-title]');
    const copy = hero.querySelector('[data-hero-copy]');
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const previous = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');

    if (!dataNode || !heroImage || !kicker || !script || !title || !copy || dots.length === 0) return;

    let slides;
    try {
      slides = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('Unable to read the Tianliang hero slides.', error);
      return;
    }
    if (!Array.isArray(slides) || slides.length === 0) return;

    hero.dataset.weiyuReady = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const holdMs = Math.max(4000, Number(hero.dataset.holdMs) || 4000);
    const transitionMs = Math.max(1000, Number(hero.dataset.transitionMs) || 1000);
    const halfTransition = transitionMs / 2;
    const activeDotClass = dots[0].className;
    let currentSlide = 0;
    let slideTimer;
    let imageSwapTimer;

    slides.slice(1).forEach(function (slide) {
      if (!slide.image) return;
      const preload = new Image();
      preload.src = slide.image;
    });

    function setText(slide) {
      kicker.textContent = slide.kicker || '';
      script.textContent = slide.script || '';
      title.replaceChildren();
      [slide.titleLine1, slide.titleLine2].filter(Boolean).forEach(function (line) {
        const span = document.createElement('span');
        span.textContent = line;
        title.appendChild(span);
      });
      copy.textContent = slide.copy || '';
    }

    function renderSlide(index, immediate) {
      const slide = slides[index];
      currentSlide = index;
      hero.dataset.layout = slide.layout || 'wide';
      hero.dataset.slide = String(index);
      window.clearTimeout(imageSwapTimer);

      if (immediate || reduceMotion.matches) {
        heroImage.src = slide.image;
        heroImage.alt = slide.imageAlt || '';
        heroImage.style.objectPosition = slide.position || 'center';
        heroImage.style.opacity = '1';
      } else {
        heroImage.style.opacity = '0';
        imageSwapTimer = window.setTimeout(function () {
          heroImage.src = slide.image;
          heroImage.alt = slide.imageAlt || '';
          heroImage.style.objectPosition = slide.position || 'center';
          heroImage.style.opacity = '1';
        }, halfTransition);
      }

      setText(slide);
      const dotsContainer = hero.querySelector('._heroDots_1l991_439');
      if (dotsContainer) {
        dotsContainer.setAttribute('aria-label', (dotsContainer.dataset.statusTemplate || '').replace('[current]', String(index + 1)).replace('[total]', String(slides.length)));
      }
      dots.forEach(function (dot, dotIndex) {
        dot.className = dotIndex === index ? activeDotClass : '';
        dot.setAttribute('aria-pressed', String(dotIndex === index));
      });
    }

    function pauseTimer() {
      window.clearTimeout(slideTimer);
    }

    function resetTimer(waitForTransition) {
      pauseTimer();
      if (reduceMotion.matches || document.hidden || !hero.isConnected || window.Shopify?.designMode) return;
      const delay = holdMs + (waitForTransition ? transitionMs : 0);
      slideTimer = window.setTimeout(function advance() {
        if (!hero.isConnected) return;
        renderSlide((currentSlide + 1) % slides.length, false);
        slideTimer = window.setTimeout(advance, holdMs + transitionMs);
      }, delay);
    }

    heroImage.style.transition = reduceMotion.matches ? 'none' : 'opacity ' + halfTransition + 'ms ease';
    renderSlide(0, true);
    resetTimer(false);

    if (previous) {
      previous.addEventListener('click', function () {
        renderSlide((currentSlide - 1 + slides.length) % slides.length, false);
        resetTimer(true);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        renderSlide((currentSlide + 1) % slides.length, false);
        resetTimer(true);
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        renderSlide(Number(dot.dataset.heroDot), false);
        resetTimer(true);
      });
    });

    hero.addEventListener('mouseenter', pauseTimer);
    hero.addEventListener('mouseleave', function () { resetTimer(false); });
    hero.addEventListener('focusin', pauseTimer);
    hero.addEventListener('focusout', function (event) {
      if (!hero.contains(event.relatedTarget)) resetTimer(false);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseTimer();
      else resetTimer(false);
    });
    const onMotionChange = function () {
      heroImage.style.transition = reduceMotion.matches ? 'none' : 'opacity ' + halfTransition + 'ms ease';
      resetTimer(false);
    };
    reduceMotion.addEventListener('change', onMotionChange);
    const onUnload = function (event) {
      if (!event.target.contains(hero)) return;
      pauseTimer();
      window.clearTimeout(imageSwapTimer);
      reduceMotion.removeEventListener('change', onMotionChange);
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    document.addEventListener('shopify:section:unload', onUnload);
  }

  function initDrawer(scope) {
    const root = scope.querySelector ? scope : document;
    const drawer = root.querySelector('[data-drawer]');
    const shade = root.querySelector('[data-drawer-shade]');
    const openButton = root.querySelector('[data-menu-open]');
    if (!drawer || !shade || !openButton || drawer.dataset.weiyuReady === 'true') return;

    drawer.dataset.weiyuReady = 'true';
    const closeButtons = Array.from(root.querySelectorAll('[data-menu-close]'));

    function setDrawer(open) {
      drawer.classList.toggle('standalone-open', open);
      shade.classList.toggle('standalone-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      drawer.inert = !open;
      openButton.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('standalone-lock', open);
      if (open) {
        const firstLink = drawer.querySelector('a, button');
        if (firstLink) firstLink.focus();
      }
    }

    drawer.inert = true;
    openButton.addEventListener('click', function () { setDrawer(true); });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () { setDrawer(false); });
    });
    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { setDrawer(false); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        setDrawer(false);
        openButton.focus();
      }
    });
  }

  let editorView = null;
  function routeHome(scroll) {
    const plans = document.getElementById('plans-page');
    const about = document.getElementById('about-page');
    const homes = document.querySelectorAll('.weiyu-view-home');
    if (!homes.length) return;
    const hash = window.location.hash;
    const view = editorView || (['#plans', '#plan-options', '#plan-benefits'].includes(hash) ? 'plans' : ['#about', '#about-story'].includes(hash) ? 'about' : 'home');
    document.querySelectorAll('.weiyu-view-home, .weiyu-view-about, .weiyu-view-plans').forEach(function (node) {
      node.hidden = !node.classList.contains('weiyu-view-' + view);
    });
    ['site-header', 'site-footer'].forEach(function (id) {
      const node = document.getElementById('shopify-section-' + id);
      if (node) node.hidden = view !== 'home';
    });
    if (plans) plans.hidden = view !== 'plans';
    if (about) about.hidden = view !== 'about';
    const currentPage = view === 'plans' ? plans : view === 'about' ? about : null;
    document.title = currentPage ? currentPage.dataset.routerTitle || '' : document.documentElement.dataset.defaultTitle;
    if (scroll) window.requestAnimationFrame(function () {
      if (['#plans', '#about', '#top', ''].includes(hash)) window.scrollTo({ top: 0, behavior: 'instant' });
      else {
        const target = document.getElementById(hash.slice(1));
        if (target) target.scrollIntoView();
      }
    });
  }
  function initHomeRouter() {
    if (!document.querySelector('.weiyu-view-home')) return;
    if (document.documentElement.dataset.weiyuRouterReady !== 'true') {
      document.documentElement.dataset.weiyuRouterReady = 'true';
      document.documentElement.dataset.defaultTitle = document.title;
      window.addEventListener('hashchange', function () { editorView = null; routeHome(true); });
    }
    routeHome(false);
  }
  function selectEditorView(event) {
    const root = event.target.closest('.shopify-section');
    if (!root) return;
    editorView = root.classList.contains('weiyu-view-plans') ? 'plans' : root.classList.contains('weiyu-view-about') ? 'about' : 'home';
    routeHome(false);
    const details = event.target.closest('details');
    if (details) details.open = true;
  }
  document.addEventListener('shopify:section:select', selectEditorView);
  document.addEventListener('shopify:block:select', selectEditorView);


  function initProduct(scope) {
    const root = scope.querySelector('[data-product-section]');
    if (!root || root.dataset.variantReady === 'true') return;
    root.dataset.variantReady = 'true';

    const select = root.querySelector('[data-variant-select]');
    if (!select) return;

    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-product-compare-price]');
    const addButton = root.querySelector('[data-add-to-cart]');

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';

      price.textContent = option.dataset.price;
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = !option.dataset.comparePrice;
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  }

  function init(scope) {
    initHero(scope || document);
    initDrawer(scope || document);
    initHomeRouter();
    initProduct(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
